import moment from 'moment'

export function toIsoDate(dateTime: string | undefined | null): string {
  return dateTime ? moment(dateTime).format('YYYY-MM-DD') : ''
}
